import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzInProductTrialsVideo } from './GzInProductTrialsVideo';
import { ButtonColor, ButtonType, FontSize } from '../../../../ui/gzIconButton/types';

export class GzInProductTrialsVideoWebComponent extends LitElement implements GzInProductTrialsVideo {
  static get styles() {
    return styles;
  }

  @property({ type: String, attribute: true, reflect: true })
  source = '';

  @property({ type: Boolean, attribute: true, reflect: true })
  isOpen = false;

  @property({ type: Number, attribute: true, reflect: true })
  public overlayZIndex = 9999;

  public static computeVideoComponent(source: String) {
    const videoConfigs: GzInProductTrialsVideo = {
      isOpen: true,
      source: source,
    };

    const videoComponent = new GzInProductTrialsVideoWebComponent();
    for (const prop in videoConfigs) {
      if (videoConfigs.hasOwnProperty(prop)) {
        videoComponent[prop] = videoConfigs[prop];
      }
    }

    document.body.appendChild(videoComponent);
    if (videoConfigs.isOpen) {
      videoComponent.open();
    }

    return videoComponent;
  }

  render() {
    return html`
      <div class="overlay" style="z-index:${this.overlayZIndex}">
        <div class="video">
          <gz-icon-button
            @click="${this.close}"
            class="video-close"
            icon="ds-icon-clear"
            fontsize="${FontSize.ICON_SIZE_24}"
            buttontype="${ButtonType.SQUARE}"
            buttoncolor="${ButtonColor.WHITE}"
          >
          </gz-icon-button>
          <iframe frameborder="0" src="${this.source}"></iframe>
        </div>
      </div>
    `;
  }

  public open() {
    this.isOpen = true;
    this.addBodyMask();
  }

  public close() {
    this.isOpen = false;
    this.removeBodyMask();
    document.body.removeChild(this);
  }

  private addBodyMask() {
    document.body.style.overflow = 'hidden';
  }

  private removeBodyMask() {
    document.body.style.overflow = 'visible';
  }
}
